import React from "react";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import patronsImage from "../assets/img/leadership/Shri Mahesh Agrawal.png";

export default function HonorablePatron() {
  return (
    <>
      <MetaInfo param="" id="about" />

      <Header school="common" />

      <main className="overflow-hidden bg-white text-[#132337]">

        <section className="relative isolate min-h-[60vh] overflow-hidden bg-[#071A2F] text-white">
          <div className="absolute inset-0 -z-30 bg-[#071A2F]" />
          <div className="absolute left-0 top-0 -z-20 h-full w-full bg-[radial-gradient(circle_at_15%_20%,rgba(139,30,63,0.24),transparent_32%),radial-gradient(circle_at_80%_15%,rgba(213,173,87,0.16),transparent_28%)]" />
          <div className="absolute right-0 top-0 -z-10 hidden h-full w-[46%] border-l border-white/10 bg-white/[0.025] lg:block" />
          <div className="absolute right-[7%] top-[18%] -z-10 hidden h-[420px] w-[420px] rounded-full border border-[#D5AD57]/15 xl:block" />
          <div className="absolute right-[11%] top-[23%] -z-10 hidden h-[320px] w-[320px] rounded-full border border-white/10 xl:block" />

          <div className="mx-auto grid min-h-[60vh] w-[min(1380px,calc(100%-48px))] items-end gap-12 pb-0 pt-[70px] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_500px] lg:items-center lg:gap-20 lg:pb-0">
            <div className="max-w-[700px]">
              <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                <span className="h-px w-12 bg-current" />
                Hon'ble Patron
              </div>

              <h1 className="mt-7 max-w-[820px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.2vw,92px)] font-normal leading-[0.96] tracking-[-0.045em]">
                An enduring vision for
                <span className="block text-[#D5AD57]">
                  education and growth.
                </span>
              </h1>

              <p className="mt-8 max-w-[620px] text-[17px] leading-8 text-white/65">
                Supporting an educational philosophy centred on knowledge, skill development, employability and responsible citizenship.
              </p>
            </div>

            <div className="relative self-end">
              <div className="absolute -left-8 top-16 hidden h-[72%] w-[1px] bg-[#D5AD57]/60 lg:block" />
              <div className="relative min-h-[560px] overflow-hidden bg-[#EAE5DA] sm:min-h-[640px] lg:min-h-[690px]">
                <img src={patronsImage} alt="Shri Mahesh Agrawal" className="absolute inset-0 h-full w-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/45 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 border-t border-white/15 bg-[#071A2F]/75 px-7 py-6 backdrop-blur-md">
                  <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[26px] text-white">Shri Mahesh Agrawal</p>
                  <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">Hon'ble Patron</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
          <div className="absolute left-0 top-0 h-full w-px bg-[#071A2F]/[0.04]" />
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[330px_1fr] lg:gap-24">
            <aside className="lg:sticky lg:top-[160px] lg:self-start">
              <div className="border-t border-[#8B1E3F] pt-6">
                <span className="text-xs font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">Hon'ble Patron</span>
                <h2 className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal leading-[1.05] text-[#071A2F]">Shri Mahesh Agrawal</h2>
              </div>

              <div className="mt-10 flex items-center gap-4 border-y border-[#071A2F]/10 py-6">
                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[64px] leading-none text-[#D5AD57]">“</span>
                <span className="h-px flex-1 bg-[#071A2F]/10" />
              </div>
            </aside>

            <div className="relative">
              <div className="absolute -left-10 top-0 hidden h-full w-px bg-[#071A2F]/10 lg:block" />
              <div className="space-y-8">
                <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,42px)] font-normal leading-[1.35] text-[#071A2F]">ISBM University was established in the year 2016 with an objective to cater the multifaceted educational needs of the millions. Its philosophy includes offering multiple courses and programmes for the students, preparing them to become successful in life and eventually to become responsible citizens of the country. We encourage them to develop their personality, by metamorphosing and nurturing them to become employable as well as venture into entrepreneurship. In a nutshell, we take all our efforts for academic growth & skill development of the students.</p>
                <p className="text-[17px] leading-9 text-[#4F5D70]">Knowledge is the key to unlock the career of young men and women. ISBM University provides the platform for learning & research. Problem solving & decision making are dual objectives of learning.</p>
                <p className="text-[17px] leading-9 text-[#4F5D70]">The challenges are accepted in collaboration with the stakeholder's viz. other Universities, research institutions, members of the faculty & society at large. The academic programmes are need-based catering to the needs of mankind. Excellence & relevance is a key parameter. It is to be set by the academic community & drive to achieve it. It is equally important we keep close to our communities both in the interest of our country and our neighborhood. It will help to ensure the on-going relevant academic programmes. I welcome all and congratulate the students, parents for choosing our University. I am sure that all stakeholders will be immensely benefited by an excellent academic pursuit.</p>

              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}
